import { useEffect } from 'react';
import { dispatcher } from 'dispatcher';
import { useSetCurrentLanguage } from 'lang';

export const useLegacyLanguageSelector = () => {
    const setCurrentLanguage = useSetCurrentLanguage();

    useEffect(() => {
        dispatcher.listen('user:action:changeLanguage', setCurrentLanguage);

        return () => {
            dispatcher.removeListener('user:action:changeLanguage', setCurrentLanguage);
        };
    }, [setCurrentLanguage]);
};
